import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

export function setRefreshToken(state, token) {
  Vue.$cookies.set('refresh', token);
  state.refresh_token = token;
}

export function setUserIsLogged(state, value) {
  Vue.$cookies.set('userIsLogged', value);
  state.isLogged = value;
}

export function setUserData(state, data) {
  state.userData = data;
  Vue.$cookies.set('userId', data['id']);
  Vue.$cookies.set('userName', data['name']);
  if (state.type != 'parent') {
    Vue.$cookies.set('parentName', data['parent']['name']);
    Vue.$cookies.set('parentId', data['parent']['id']);
    Vue.$cookies.set('childFirstTime', data.moduleFocusOn == null);
    state.childFirstTime = data.moduleFocusOn == null;
  }
}

export function setchildrenIds(state, ids) {
  state.hasChildren = true;
  state.childrenIds = ids;
}

export function logout(state) {
  state.access_token = '';
  state.refresh_token = '';
  state.userData = {};
  state.type = '';
  state.hasChildren = false;
  state.childrenIds = [];
  state.childrenData = [];
  state.childSelectedId = '';
  state.childSelectedName = '';
  state.ChildselectedEmail = '';
  state.childrenCounter = 0;
  state.isLogged = false;
  state.error = false;
  state.errorMessage = '';
  state.childDataGetted = false;
  state.genders = [];
  state.childFirstTime = true;
}

export function setChildrenData(state, data) {
  state.childrenData = data;
  Vue.$cookies.set('childCount', data.length);
  state.childrenCounter = data.length;
}

export function registerError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
}

export function cleanErrors(state) {
  state.error = false;
  state.errorMessage = '';
}

export function setChildSelectedData(state, payload) {
  Vue.$cookies.set('childSelectedId', payload.id);
  Vue.$cookies.set('childSelectedName', payload.name);
  Vue.$cookies.set('theme', payload.themeSelection);
  state.theme = payload.themeSelection;
  state.childSelectedId = payload.id;
  state.childSelectedName = payload.name;
}

export function markUniqueChildAsSelected(state) {
  const children = state.childrenData[0].child;
  Vue.$cookies.set('childSelectedId', children.id);
  Vue.$cookies.set('childSelectedName', children.name);
  Vue.$cookies.set('theme', children.themeSelection);
  state.theme = children.themeSelection;
  state.childSelectedId = children.id;
  state.childSelectedName = children.name;
}

export function setUserType(state, type) {
  Vue.$cookies.set('userType', type);
  state.type = type;
}

export function saveGenders(state, payload) {
  state.genders = payload;
}

export function incrementChildCount(state) {
  let length = parseInt(Vue.$cookies.get('childCount'));
  Vue.$cookies.set('childCount', length + 1);
  state.childrenCounter = length + 1;
}

export function childFirstTimeComplete(state) {
  Vue.$cookies.set('childFirstTime', false);
  state.childFirstTime = false;
}
export function setDarkMode(state, dark) {

  Vue.$cookies.set('dark', dark);
  state.dark = dark;
}

export function themeChange(state, data) {
  Vue.$cookies.set('theme', data);
  state.theme = data;
}

export function error(state, error) {
  state.error = true;
  state.errorMessage = error;
}
